import React, {Component} from 'react'
import './InsuranceEligibilityScreen.css'
import {Col, Container, Nav, Row, Tab} from "react-bootstrap";
import InsuranceAppointment from "./v2/appointment/InsuranceAppointment";
import ClaimList from "./v2/claims/ClaimList";
import MedicalTouristClaimList from "./v2/claims/MedicalTouristClaimList";
import SelfPayClaimList from "./v2/claims/SelfPayClaimList";
import UnclaimedInvoiceList from "./v2/claims/UnclaimedInvoiceList";
import PayAndClaimV2 from "./v2/claims/PayAndClaimV2";
import queryString from "query-string";
import PreApproval from "./v2/preapproval/PreApproval";
import DirectBilling from "./v2/directbilling/DirectBilling";
import ClaimRemittance from "./claimRemittance/ClaimRemittance";
import AuthService from "../../../services/auth-service/AuthService";
import InsuranceDirect from "./direct/InsuranceDirectPay";

export default class InsuranceEligibilityScreen extends Component {
    constructor(props) {
        super(props);

        this.tabVisibility = {
            todaysAppointments: AuthService.userHasAnyAuthority(["VIEW_INSURANCE_APPOINTMENTS", "UPDATE_INSURANCE_APPOINTMENTS"]),
            directBilling: AuthService.userHasAnyAuthority(["VIEW_INSURANCE_PRE_APPROVAL", "UPDATE_INSURANCE_PRE_APPROVAL"]),
            payAndClaim: AuthService.userHasAnyAuthority(["VIEW_INSURANCE_PAY_AND_CLAIM", "UPDATE_INSURANCE_PAY_AND_CLAIM"]),
            claimGeneration: AuthService.userHasAnyAuthority(["VIEW_INSURANCE_CLAIM", "UPDATE_INSURANCE_CLAIM"]),
            claimList: AuthService.userHasAnyAuthority(["VIEW_INSURANCE_CLAIM", "UPDATE_INSURANCE_CLAIM"]),
            claimRemittance: AuthService.userHasAuthority("VIEW_INSURANCE_CLAIM_REMITTANCE")
        };

        const values = queryString.parse(this.props.location.search);
        const requestedTab = values.selectedTab;
        const defaultTab = this.tabVisibility[requestedTab]
            ? requestedTab
            : Object.keys(this.tabVisibility).find(tab => this.tabVisibility[tab]) || "todaysAppointments";

        this.state = {selectedTab: defaultTab, claimFocus: null};
    }

    selectTab = (key, extraState) => {
        // One update, so the Claim tab sees its focus together with being selected
        this.setState({selectedTab: key, ...extraState});
        this.props.history.push({
            search: "?" + new URLSearchParams({selectedTab: key}).toString()
        });
    }

    // From a remittance row: the Claim tab lists only that claim (a new object each time, so a repeat click refetches)
    goToClaim = (claimId) => {
        this.selectTab("claimList", {claimFocus: {claimId}});
    }

    render() {
        const {selectedTab} = this.state;

        return (
            <Container style={{maxWidth: '100%'}}>
                <Row>
                    <Col xs={12}>
                        <div className="InsuranceScreen">
                            <Tab.Container activeKey={selectedTab} id="insurance-tabs"
                                           className="InsuranceTabs"
                                           onSelect={key => this.selectTab(key)}>
                                <Row>
                                    <Col sm={12}>
                                        <Nav variant="tabs" className="flex-row">
                                            {this.tabVisibility.todaysAppointments &&
                                            <Nav.Item>
                                                <Nav.Link eventKey="todaysAppointments">Appointments</Nav.Link>
                                            </Nav.Item>}
                                            <Nav.Item>
                                                <Nav.Link eventKey="preApproval">Pre Approval</Nav.Link>
                                            </Nav.Item>
                                            {this.tabVisibility.directBilling &&
                                            <Nav.Item>
                                                <Nav.Link eventKey="directBilling">Direct Billing</Nav.Link>
                                            </Nav.Item>}
                                            {this.tabVisibility.payAndClaim &&
                                            <Nav.Item>
                                                <Nav.Link eventKey="payAndClaim">Pay & Claim</Nav.Link>
                                            </Nav.Item>}
                                            {this.tabVisibility.claimGeneration &&
                                            <Nav.Item>
                                                <Nav.Link eventKey="claimGeneration">Generate Claims</Nav.Link>
                                            </Nav.Item>}
                                            {this.tabVisibility.claimList &&
                                            <Nav.Item>
                                                <Nav.Link eventKey="claimList">Claim</Nav.Link>
                                            </Nav.Item>}
                                            {this.tabVisibility.claimList &&
                                            <Nav.Item>
                                                <Nav.Link eventKey="medicalTouristClaim">Medical Tourist</Nav.Link>
                                            </Nav.Item>}
                                            {this.tabVisibility.claimList &&
                                            <Nav.Item>
                                                <Nav.Link eventKey="selfPayClaim">Self-Pay</Nav.Link>
                                            </Nav.Item>}
                                            {this.tabVisibility.claimRemittance &&
                                            <Nav.Item>
                                                <Nav.Link eventKey="claimRemittance">Claim Remittance</Nav.Link>
                                            </Nav.Item>}
                                        </Nav>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col sm={12}>
                                        <Tab.Content>
                                            {this.tabVisibility.todaysAppointments &&
                                            <Tab.Pane eventKey="todaysAppointments">
                                                <InsuranceAppointment selected={selectedTab === "todaysAppointments"} />
                                            </Tab.Pane>}
                                            <Tab.Pane eventKey="preApproval">
                                                <PreApproval selected={selectedTab === "preApproval"} />
                                            </Tab.Pane>
                                            {this.tabVisibility.directBilling &&
                                                <Tab.Pane eventKey="directBilling">
                                                <DirectBilling selected={selectedTab === "directBilling"} />
                                            </Tab.Pane>}
                                            {this.tabVisibility.payAndClaim &&
                                            <Tab.Pane eventKey="payAndClaim">
                                                <PayAndClaimV2 selected={selectedTab === "payAndClaim"} />
                                            </Tab.Pane>}
                                            {this.tabVisibility.claimGeneration &&
                                            <Tab.Pane eventKey="claimGeneration">
                                                <UnclaimedInvoiceList selected={selectedTab === "claimGeneration"} />
                                            </Tab.Pane>}
                                            {this.tabVisibility.claimList &&
                                            <Tab.Pane eventKey="claimList">
                                                <ClaimList selected={selectedTab === "claimList"} claimFocus={this.state.claimFocus} />
                                            </Tab.Pane>}
                                            {this.tabVisibility.claimList &&
                                            <Tab.Pane eventKey="medicalTouristClaim">
                                                <MedicalTouristClaimList selected={selectedTab === "medicalTouristClaim"} />
                                            </Tab.Pane>}
                                            {this.tabVisibility.claimList &&
                                            <Tab.Pane eventKey="selfPayClaim">
                                                <SelfPayClaimList selected={selectedTab === "selfPayClaim"} />
                                            </Tab.Pane>}
                                            {this.tabVisibility.claimRemittance &&
                                            <Tab.Pane eventKey="claimRemittance">
                                                <ClaimRemittance selected={selectedTab === "claimRemittance"} onGoToClaim={this.tabVisibility.claimList ? this.goToClaim : null} />
                                            </Tab.Pane>}
                                        </Tab.Content>
                                    </Col>
                                </Row>
                            </Tab.Container>
                        </div>
                    </Col>
                </Row>
            </Container>
        );
    }
}
